interface NestedObject {
  // eslint-disable-next-line
  [key: string]: any;
}

export default class EqualityHelper {
  static isEqualDeep(o1: NestedObject, o2: NestedObject) {
    return [...Object.keys(o1), ...Object.keys(o2)].every((k) => {
      const val1 = o1[k];
      const val2 = o2[k];
      if (typeof val1 !== typeof val2) {
        return false;
      }
      if (Array.isArray(val1)) {
        return val1.every((v, index) => v === val2[index]);
      }
      return o1[k] === o2[k];
    });
  }
}
